<template>
  <flat-pickr :value="value" @input="$emit('input', $event)" :config="opt" :class="classes" @on-change=onChange />
</template>

<script>
import parse from 'date-fns/parse';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: () => ({})
    },
    classes: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      default: {
        wrap: true,
        dateFormat: 'Y-m-d',
        altFormat: 'd/m/Y',
        altInput: true,
        allowInput: true,
        enableTime: false,
        // defaultDate: '',
        parseDate: (dateStr) => {
          if (dateStr === '0000-00-00' || dateStr === '') return false;
          return parse(dateStr, 'dd/MM/yyyy', new Date());
        }
      }
    };
  },
  computed: {
    opt() {
      return { ...this.default, ...this.config };
    }
  },
  methods: {
    onChange(event, date) {
      this.$emit('on-change', event, date);
    }
  },
};
</script>
